// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falArrowUpArrowDown: CreateIconOptions = {
  "displayName": "FALArrowUpArrowDown",
  "viewBox": "0, 0, 576, 512",
  "d": "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6 144 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zm352 342.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 425.4 432 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 377.4-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96z"
};
